class LqdFancyBoxHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initSplitText();
    this.initCustomAnimation();
    this.initInView();
    this.initParallax();
    this.initHover3d();
    this.initReveal();
    this.initResponsiveBg();
    this.initSlideElementOnHover();

  }

  getDefaultSettings() {
    return {
      selectors: {
        splitTextElement: '[data-split-text]',
        customAnimationElement: '[data-custom-animations]',
        parallaxElement: '[data-parallax]',
        hover3dElement: '[data-hover3d]',
        revealElement: '[data-reveal]',
        inViewElement: '[data-inview]',
        responsiveBgElement: '[data-responsive-bg]',
        slideElementOnHoverElement: '[data-slideelement-onhover]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $splitTextElement: this.$element.find(selectors.splitTextElement),
      $customAnimationElement: this.$element.find(selectors.customAnimationElement),
      $parallaxElement: this.$element.find(selectors.parallaxElement),
      $hover3dElement: this.$element.find(selectors.hover3dElement),
      $revealElement: this.$element.find(selectors.revealElement),
      $inViewElement: this.$element.find(selectors.inViewElement),
      $responsiveBgElement: this.$element.find(selectors.responsiveBgElement),
      $slideElementOnHoverElement: this.$element.find(selectors.slideElementOnHoverElement),
    }
  }

  initSplitText() {

    this.elements.$customAnimationElement.liquidSplitText();

  }

  initCustomAnimation() {

    this.elements.$customAnimationElement.liquidCustomAnimations();

  }

  initHover3d() {

    this.elements.$hover3dElement.liquidHover3d();

  }

  initParallax() {

    this.elements.$parallaxElement.liquidParallax();

  }

  initReveal() {

    this.elements.$revealElement.liquidReveal();

  }

  initInView() {

    this.elements.$inViewElement.liquidInView();

  }

  initResponsiveBg() {

    this.elements.$responsiveBgElement.liquidResponsiveBG();
    
  }

  initSlideElementOnHover() {

    this.elements.$slideElementOnHoverElement.liquidSlideElement();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleSplitTextDestroy();
    this.handleCustomAnimationDestroy();
    this.handleParallaxDestroy();
    this.handleHover3dDestroy();
    this.handleSlideElementDestroy();

  }

  handleSplitTextDestroy() {

    if ( ! this.elements.$splitTextElement.length ) return;

    const splitTextData = this.elements.$splitTextElement.data('plugin_liquidSplitText');

    if ( splitTextData ) {
      splitTextData.destroy();
    }

  }

  handleCustomAnimationDestroy() {

    if ( ! this.elements.$customAnimationElement.length ) return;

    const customAnimationData = this.elements.$customAnimationElement.data('plugin_liquidCustomAnimations');

    if ( customAnimationData ) {
      customAnimationData.destroy();
    }

  }

  handleParallaxDestroy() {

    if ( ! this.elements.$parallaxElement.length ) return;

    const parallaxData = this.elements.$parallaxElement.data('plugin_liquidParallax');

    if ( parallaxData ) {
      parallaxData.destroy();
    }

  }

  handleHover3dDestroy() {

    if ( ! this.elements.$hover3dElement.length ) return;

    const hover3dData = this.elements.$hover3dElement.data('plugin_liquidHover3d');

    if ( hover3dData ) {
      hover3dData.destroy();
    }

  }

  handleSlideElementDestroy() {

    if ( ! this.elements.$slideElementOnHoverElement.length ) return;

    const slideElementData = this.elements.$slideElementOnHoverElement.data('plugin_liquidSlideElement');

    if ( slideElementData ) {
      slideElementData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdFancyBoxHandler, { $element } );
};